const root = document.documentElement;

const bkColor = process.env.REACT_APP_BACKGROUND_COLOR || '#75cae3';

// Set CSS variables for the root element for make a different themes between PROD and STAGE.
root.style.setProperty('--color_background', bkColor);
